import Vue from 'vue';
import axios from 'axios';

var baseUrl = process.env.apiUrl;

export default {
  resetPassword(emailAddress) {
    return axios.post(baseUrl + '/resetpassword', { emailAddress: emailAddress });
  },

  checkToken(resetToken) {
    return axios.post(baseUrl + '/resetpassword/checktoken', { token: resetToken });
  },

  saveNewPassword(resetToken, password) {
    return axios.post(baseUrl + '/resetpassword/savenewpassword', { token: resetToken, password: password });
  }
}



// WEBPACK FOOTER //
// ./src/services/ResetPasswordService.js